export default "__VITE_ASSET__CYx4QtXT__"